// Mock data for 518 Courier website

export const COMPANY = {
  name: "518 Courier",
  legalName: "OBLED Corporation d/b/a 518 Courier",
  logo: "/logo-518.png",
  phone: "(518) 954-4701",
  email: "info@518courier.com",
  address: "1321 Pleasant St, Schenectady, NY 12303",
  hours: "24 / 7 Dispatch · Mon–Sun",
  founded: 2024,
  social: {
    facebook: "#",
    instagram: "#",
    linkedin: "#",
    twitter: "#"
  }
};

export const NAV_LINKS = [
  { label: "Home", path: "/" },
  { label: "Services", path: "/services" },
  { label: "About", path: "/about" },
  { label: "Compliance", path: "/compliance" },
  { label: "Tracking", path: "/tracking" },
  { label: "Get a Quote", path: "/get-a-quote" }
];

export const FOOTER_LINKS = [
  { label: "Home", path: "/" },
  { label: "Services", path: "/services" },
  { label: "About", path: "/about" },
  { label: "Tracking", path: "/tracking" },
  { label: "Contact", path: "/contact" },
  { label: "Compliance & Safety", path: "/compliance" }
];

export const LEGAL_LINKS = [
  { label: "Terms & Conditions", path: "/conditions" },
  { label: "Customer Terms", path: "/customer-terms" },
  { label: "Driver Terms", path: "/driver-terms" },
  { label: "Privacy Policy", path: "/privacy" },
  { label: "HIPAA Privacy Notice", path: "/hipaa-notice" },
  { label: "Accessibility", path: "/accessibility" },
  { label: "SOPs", path: "/sops" }
];

export const HERO = {
  eyebrow: "Albany · Capital Region · Hudson Valley",
  title: "Fast, Reliable Courier Service",
  titleAccent: "Across the 518.",
  subtitle:
    "Same-day delivery, medical specimen transport and on-demand logistics — dispatched 24/7 from our Albany hub. When it has to be there, it gets there.",
  primaryCta: { label: "Request a Quote", path: "/contact" },
  secondaryCta: { label: "Schedule a Delivery", path: "/contact" },
  stats: [
    { value: "24/7", label: "Live dispatch" },
    { value: "Local", label: "Capital Region + NY/MA/CT/VT" },
    { value: "Same-day", label: "Rush pickups" },
    { value: "Direct", label: "No hubs, no delays" }
  ],
  image:
    "https://images.unsplash.com/photo-1620455800201-7f00aeef12ed?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHwyfHxjb3VyaWVyJTIwdmFufGVufDB8fHx8MTc4MDI1MzQwOHww&ixlib=rb-4.1.0&q=85"
};

export const SERVICES = [
  {
    id: "same-day",
    icon: "Truck",
    title: "Same-Day Delivery",
    short:
      "On-demand pickup and drop-off across the Capital Region, subject to driver availability.",
    details: [
      "Direct, non-stop routing",
      "Live GPS tracking",
      "Signature & photo proof of delivery",
      "Pickups from any zip in the 518"
    ],
    image:
      "https://images.unsplash.com/photo-1543499459-d1460946bdc6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHw0fHxkZWxpdmVyeSUyMGRyaXZlcnxlbnwwfHx8fDE3ODAyNTM0MDh8MA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: "medical",
    icon: "HeartPulse",
    title: "Medical & Lab Courier",
    short:
      "Transport of specimens, pharmaceuticals and patient records for local labs, clinics and pharmacies.",
    details: [
      "Handled per client packaging requirements",
      "Trained, authorized local drivers",
      "Priority routes for clinics & labs",
      "Chain-of-custody documentation"
    ],
    image:
      "https://images.pexels.com/photos/6169129/pexels-photo-6169129.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
  },
  {
    id: "legal",
    icon: "FileText",
    title: "Legal & Business Documents",
    short:
      "Confidential delivery of contracts, court filings and sensitive paperwork.",
    details: [
      "Same-day filings to courthouses",
      "Sealed envelope protocol",
      "Notarized POD on request",
      "Recurring inter-office routes"
    ],
    image:
      "https://images.unsplash.com/photo-1566576721346-d4a3b4eaeb55?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwxfHxkZWxpdmVyeSUyMGRyaXZlcnxlbnwwfHx8fDE3ODAyNTM0MDh8MA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: "logistics",
    icon: "Warehouse",
    title: "Warehouse & Logistics",
    short:
      "Pallet runs, route distribution and last-mile fulfillment for local businesses.",
    details: [
      "Box truck & cargo van fleet",
      "Scheduled multi-stop routes",
      "Lift-gate & dolly equipped",
      "Weekly recurring contracts"
    ],
    image:
      "https://images.pexels.com/photos/4487383/pexels-photo-4487383.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
  },
  {
    id: "express",
    icon: "Zap",
    title: "Rush / Express",
    short: "When minutes matter — direct, lights-on, no-stop service.",
    details: [
      "Fastest available response, availability depending on driver location",
      "Dedicated single-package driver",
      "Priority dispatch lane",
      "24/7 availability"
    ],
    image:
      "https://images.unsplash.com/photo-1587813369290-091c9d432daf?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHwxfHxjb3VyaWVyJTIwdmFufGVufDB8fHx8MTc4MDI1MzQwOHww&ixlib=rb-4.1.0&q=85"
  },
  {
    id: "scheduled",
    icon: "CalendarClock",
    title: "Scheduled Routes",
    short:
      "Daily, weekly or recurring pickups built around your operations.",
    details: [
      "Custom route engineering",
      "Dedicated account manager",
      "Monthly billing & reporting",
      "Consistent recurring delivery windows"
    ],
    image:
      "https://images.unsplash.com/photo-1553413077-190dd305871c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHwzfHx3YXJlaG91c2UlMjBsb2dpc3RpY3N8ZW58MHx8fHwxNzgwMjUzNDA5fDA&ixlib=rb-4.1.0&q=85"
  }
];

export const WHY_US = [
  {
    icon: "Clock",
    title: "24 / 7 live dispatch",
    text: "Real humans answer the phone — nights, weekends and holidays."
  },
  {
    icon: "MapPin",
    title: "Local to the 518",
    text: "Based in Schenectady. We know every back road across Albany, Troy, Saratoga and the Capital Region."
  },
  {
    icon: "Smartphone",
    title: "Direct communication",
    text: "Text, call or email dispatch — no chatbots, no automated call trees."
  },
  {
    icon: "Route",
    title: "Point-to-point routing",
    text: "Direct pickup to drop-off. No hubs, no sorting facilities, no extra transfers."
  },
  {
    icon: "BadgeDollarSign",
    title: "Transparent pricing",
    text: "Quoted by phone or online before the driver is dispatched. No hidden fees."
  },
  {
    icon: "Headphones",
    title: "Dedicated support",
    text: "Business accounts get a named dispatcher who knows your routes."
  }
];

export const COVERAGE = [
  "Albany",
  "Schenectady",
  "Troy",
  "Saratoga Springs",
  "Clifton Park",
  "Latham",
  "Colonie",
  "Cohoes",
  "Watervliet",
  "Rensselaer",
  "Glens Falls",
  "Hudson"
];

export const TESTIMONIALS = [];

export const PARTNERS = [];

export const TEAM = [
  {
    name: "Stephane K.",
    role: "Founder",
    bio: "Started 518 Courier in 2024 and drove the first routes himself. Still answers the dispatch line."
  }
];

export const PROCESS_STEPS = [
  {
    step: "01",
    title: "Request a pickup",
    text: "Call, text or submit the online form. Dispatch confirms your request as quickly as possible."
  },
  {
    step: "02",
    title: "We dispatch a driver",
    text: "Nearest qualified driver is routed to your pickup location with full instructions."
  },
  {
    step: "03",
    title: "Live tracking",
    text: "You receive a tracking link. Watch the package move in real time."
  },
  {
    step: "04",
    title: "Proof of delivery",
    text: "Signature, photo and timestamp delivered to your inbox the moment we drop."
  }
];

export const PACKAGE_TYPES = [
  "Envelope / documents",
  "Small parcel (< 20 lbs)",
  "Medium box (20–70 lbs)",
  "Pallet / freight",
  "Medical specimen",
  "Other"
];

// ===== Tracking sample =====
export const SAMPLE_TRACKING = {
  "518-2049": {
    id: "518-2049",
    status: "Out for delivery",
    statusKey: "out",
    eta: "14 min",
    from: "Albany Med · 43 New Scotland Ave",
    to: "St. Peter's Hospital · 315 S Manning Blvd",
    service: "Medical · Rush",
    driver: "Devon B. · Van #04",
    progress: 78,
    events: [
      { time: "2:42 PM", date: "Today", label: "Out for delivery", desc: "Driver Devon B. is en route. ETA 14 minutes.", done: true, active: true },
      { time: "2:18 PM", date: "Today", label: "Picked up", desc: "Package picked up at Albany Med, signed by R. Whitmore.", done: true },
      { time: "2:05 PM", date: "Today", label: "Driver dispatched", desc: "Devon B. assigned and routed to pickup.", done: true },
      { time: "1:58 PM", date: "Today", label: "Order received", desc: "Dispatch confirmed rush medical request.", done: true }
    ]
  },
  "518-2050": {
    id: "518-2050",
    status: "Delivered",
    statusKey: "delivered",
    eta: "—",
    from: "Delaney & Hart LLP · 100 State St, Albany",
    to: "Schenectady County Courthouse · 612 State St",
    service: "Legal · Same-Day",
    driver: "Maria S. · Van #11",
    progress: 100,
    events: [
      { time: "11:12 AM", date: "Today", label: "Delivered", desc: "Signed by Clerk J. Pratt. Photo POD sent.", done: true, active: true },
      { time: "10:48 AM", date: "Today", label: "Out for delivery", desc: "On route to Schenectady courthouse.", done: true },
      { time: "10:22 AM", date: "Today", label: "Picked up", desc: "Sealed envelope retrieved from Delaney & Hart.", done: true },
      { time: "10:05 AM", date: "Today", label: "Order received", desc: "Dispatch confirmed legal filing run.", done: true }
    ]
  }
};

// ===== Customer dashboard mock data =====
export const CUSTOMER_ORDERS = [
  { id: "518-2049", date: "Today · 1:58 PM", from: "Albany Med", to: "St. Peter's Hospital", service: "Medical Rush", status: "Out for delivery", statusKey: "out", price: "$58.00" },
  { id: "518-2031", date: "Yesterday · 4:22 PM", from: "Office · State St", to: "Schenectady Courthouse", service: "Legal Same-Day", status: "Delivered", statusKey: "delivered", price: "$45.00" },
  { id: "518-1998", date: "May 28 · 11:10 AM", from: "Warehouse · Watervliet", to: "Saratoga Distrib.", service: "Pallet · Scheduled", status: "Delivered", statusKey: "delivered", price: "$220.00" },
  { id: "518-1972", date: "May 26 · 9:34 AM", from: "Office · State St", to: "Hudson Valley Parts", service: "Standard", status: "Delivered", statusKey: "delivered", price: "$28.00" },
  { id: "518-1944", date: "May 22 · 2:15 PM", from: "Office · State St", to: "Albany Med Group", service: "Rush", status: "Cancelled", statusKey: "cancelled", price: "—" }
];

export const CUSTOMER_INVOICES = [
  { id: "INV-2025-05", period: "May 2025", deliveries: 14, amount: "$612.00", status: "Paid" },
  { id: "INV-2025-04", period: "April 2025", deliveries: 18, amount: "$845.00", status: "Paid" },
  { id: "INV-2025-03", period: "March 2025", deliveries: 22, amount: "$1,012.00", status: "Paid" }
];

// ===== Driver dashboard =====
// Removed hardcoded DRIVER_ROUTES / DRIVER_STATS demo data.
// The driver dashboard now computes all stats from the authenticated driver's
// real, scoped delivery records (see DriverDashboard.jsx + lib/deliveries.js).

// ===== Admin dashboard mock =====
export const ADMIN_STATS = [
  { label: "Today's deliveries", value: "—", change: "", icon: "Truck" },
  { label: "Active drivers", value: "—", change: "", icon: "Users" },
  { label: "Revenue (MTD)", value: "—", change: "", icon: "DollarSign" },
  { label: "On-time rate", value: "—", change: "", icon: "Clock" }
];

export const ADMIN_RECENT_ORDERS = [
  { id: "518-2049", customer: "Capital Diagnostics", driver: "Devon B.", service: "Medical Rush", status: "Out for delivery", statusKey: "out", price: "$58" },
  { id: "518-2048", customer: "Delaney & Hart", driver: "Maria S.", service: "Legal", status: "Delivered", statusKey: "delivered", price: "$45" },
  { id: "518-2047", customer: "Russo's Market", driver: "James C.", service: "Catering", status: "Delivered", statusKey: "delivered", price: "$32" },
  { id: "518-2046", customer: "Hudson Valley Parts", driver: "Alex T.", service: "Standard", status: "Picked up", statusKey: "picked", price: "$28" },
  { id: "518-2045", customer: "Empire Legal", driver: "—", service: "Rush", status: "Pending", statusKey: "pending", price: "$45" },
  { id: "518-2044", customer: "Albany Med Group", driver: "Devon B.", service: "Medical", status: "Delivered", statusKey: "delivered", price: "$48" }
];

export const ADMIN_DRIVERS = [
  { name: "Devon Brooks", id: "DRV-001", status: "On route", today: 8, rating: 4.9 },
  { name: "Maria Sanchez", id: "DRV-002", status: "On route", today: 6, rating: 5.0 },
  { name: "James Calloway", id: "DRV-003", status: "Available", today: 4, rating: 4.9 },
  { name: "Alex Thompson", id: "DRV-004", status: "On break", today: 5, rating: 4.8 },
  { name: "Priya Kapoor", id: "DRV-005", status: "On route", today: 7, rating: 4.9 },
  { name: "Tony Russo", id: "DRV-006", status: "Off duty", today: 0, rating: 4.7 }
];
